import { Component, OnInit } from '@angular/core';
import { ComponentesJsService, ConfigService } from '../../lib/service';
import { ActivatedRoute } from '@angular/router';
import Modo from '../../enums/modo';
import { GeoCode } from '../geocode';
import { TecladoComponent } from './teclado/teclado.component';

import {
    ResultadoPesquisa,
    FiltrosPesquisa,
    Pesquisa,
    DataSource
} from '../../lib/model';

import {
    LoaderService,
    PesquisaService
} from '../../lib/service';


@Component({
    selector: 'pesquisa-touch',
    template: require('./pesquisa-touch.component.html'),
    styles: [require('./pesquisa-touch.component.css')]
})
export class PesquisaTouchComponent implements OnInit {

    public filtrosPesquisa: FiltrosPesquisa;
    public resultadosPesquisa: Array<ResultadoPesquisa>;
    public pesquisa: Pesquisa;
    public resultadoMapa: ResultadoPesquisa;
    private config: ConfigService;

    public map: any;

    public enderecoOrigem: string;

    //paginação
    public paginaAtual: number;
    public totalRecords: number;


    private directionsService: any;
    private directionsDisplay: any;

    private dadosUniodontos: any;
    private registroANS: any;

    private exibirTeclado: boolean;

    constructor(private _loaderService: LoaderService, private _configService: ConfigService,
        private route: ActivatedRoute, private _pesquisaService: PesquisaService) {
        this.filtrosPesquisa = new FiltrosPesquisa();
        this.resultadosPesquisa = new Array<ResultadoPesquisa>();
        this.pesquisa = new Pesquisa();
        this.resultadoMapa = new ResultadoPesquisa();
        this.config = this._configService;

        localStorage.setItem('modo', Modo.encontreSeuDentista);
        this.pesquisa.modo = 'encontreSeuDentista';

        this.config.load();

        this.totalRecords = 0;
    }

    mostrarTeclado() {
        this.exibirTeclado = true;
    }

    esconderTeclado(event: Event) {        
        event.stopPropagation();
        this.exibirTeclado = false;

        const input = event.target;

        if(input.id == 'nomePesquisa') {
            this.pesquisa.nome = input.value;
        } else {
            this.pesquisa.CRO = input.value;
        }
    }

    getModoFromStorage() {
        return localStorage.getItem('modo');
    }

    getModo() {
        let modo = this.getModoFromStorage();
        if (modo === Modo.encontreSeuDentista) {
            return Modo.redeSubstituicao;
        } else {
            return Modo.encontreSeuDentista;
        }
    }

    notificar(title: string, message: string) {
        $.growl.notice({
            title: title,
            message: message
        });
    };

    limparDados() {
        this.pesquisa = new Pesquisa();

        if (this.getModoFromStorage() == Modo.redeSubstituicao) {
            this.pesquisa.modo = 'redeSubstituicao';
        } else {
            this.pesquisa.modo = 'encontreSeuDentista';
        }

        this.filtrosPesquisa = new FiltrosPesquisa();
        this.resultadosPesquisa = new Array<ResultadoPesquisa>();
    }

    onRedeNacionalChange(value: any) {
        const registroANS = this.route.snapshot.params['s'];

        this.limparDados();

        this.pesquisa.isRedeNacional = value;

        this._loaderService.showLoader();
        this.getFiltrosBasicos(registroANS, value, true);
    }

    initMap(resultado: ResultadoPesquisa, buscarGeoLocation: boolean = true) {
        var that = this;

        let lat = resultado.Coordenadas.Latitude;
        let lng = resultado.Coordenadas.Longitude;

        if ((lat == 0 || lng == 0) && (buscarGeoLocation)) {
            this._pesquisaService.getGeoLocation(resultado.id)
                .subscribe((result) => {
                    resultado.Coordenadas.Latitude = result.Latitude;
                    resultado.Coordenadas.Longitude = result.Longitude;

                    that.initMap(resultado, false);
                }, (error) => {
                    alert(error);
                });
        } else {
            this.directionsService = new google.maps.DirectionsService;
            this.directionsDisplay = new google.maps.DirectionsRenderer({ suppressMarkers: true });

            var mapStyles =
                [
                    {
                        featureType: "poi",
                        stylers: [
                            { visibility: "off" }
                        ]
                    }
                ];

            this.map = new google.maps.Map(document.getElementById('map-holder'), {
                center: { lat: lat, lng: lng },
                zoom: 18,
                styles: mapStyles
            });

            this.directionsDisplay.setMap(this.map);

            var contentString =

                "<div id='content'>"
                + "<div><b>Nome: </b>"
                + resultado.nome
                + "<br><b>Endereço.: </b>" + resultado.endereco
                + "<br><b>Tel.: </b>" + resultado.telefones
                + "</div>"
                + "</div>"


            var infowindow = new google.maps.InfoWindow({
                content: contentString// + index
            });


            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: this.map,
                title: resultado.nome,
                icon: '../../../public/img/marcador_uniodonto_dent_old.ico'
            });

            marker.addListener('click', () => {
                infowindow.open(this.map, marker);
            });
        }
    }


    calcularRota() {

        var that = this;

        var userLat = 0;
        var userLng = 0;

        if (this.enderecoOrigem && this.enderecoOrigem != '') {
            that.exibirRota(0, 0, this.enderecoOrigem);
        }
        else {
            if (navigator.geolocation) {

                navigator.geolocation.getCurrentPosition(function (position) {

                    userLat = position.coords.latitude;
                    userLng = position.coords.longitude;

                    that.exibirRota(userLat, userLng);

                }, function (err) {
                    alert('Erro ao recuperar localização. Utilize o campo "De onde está partindo" para ver a rota.');
                    //;alert('Erro ao recuperar localização');
                }, { timeout: 10000, enableHighAccuracy: true, maximumAge: 75000 });
            } else {
                alert('O seu browser não tem suporte à localização. Utilize o campo "De onde está partindo" para ver a rota.');
            }
        }
    }


    exibirRota(userLat: number, userLng: number, enderecoOrigem: string = '') {
        var that = this;

        that.directionsService.route({
            origin: (enderecoOrigem != '' ? enderecoOrigem : new google.maps.LatLng(userLat, userLng)),
            destination: new google.maps.LatLng(that.resultadoMapa.Coordenadas.Latitude, that.resultadoMapa.Coordenadas.Longitude),
            travelMode: google.maps.TravelMode.DRIVING,
        }, function (response: any, status: any) {
            if (status === google.maps.DirectionsStatus.OK) {

                if (enderecoOrigem != '') {
                    console.log('Verificando localizaçao');
                    userLat = response.routes[0].legs[0].start_location.lat;
                    userLng = response.routes[0].legs[0].start_location.lng;
                }

                that.createMarker(that.map, userLat, userLng, 'Você');
                that.directionsDisplay.setDirections(response);

            } else {
                window.alert('Falha ao recuperar direção: ' + status);
            }
        });
    }

    createMarker(map: any, lat: number, lng: number, title: string) {
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            map: map,
            title: title
        });
    }

    ngOnInit() {
        const body = document.getElementsByTagName('body')[0];

        body.onfocus = (event: FocusEvent) => {
            console.dir(event);
        };

        ComponentesJsService.animacaoEmBotoes();

        const registroANS = this.route.snapshot.params['s'];
        this.registroANS = registroANS;

        if (!registroANS) {
            alert('É necessário ser informado um registroANS')
        } else {
            if (registroANS == '361593') {
                this.pesquisa.isRedeNacional = true;
            }
            this.pesquisa.registroANS = registroANS;
        }

        this._loaderService.showLoader();

        this.getFiltrosBasicos(registroANS, this.pesquisa.isRedeNacional, true);

        $("#modalMapa").on("shown.bs.modal", () => {
            this.initMap(this.resultadoMapa);
        });

        this.esconderHeader();
    }

    esconderHeader() {
        const header = document.getElementById('header');

        if(header) {
            header.style.display = 'none';
        }

        const main = document.getElementById('main');

        if(main) {
            main.style.paddingTop = '0px';
        }
    }

    setValoresDefault(campo: string, registroANS: string) {
        if (!this.dadosUniodontos) {
            this._pesquisaService.getDadosUniodonto(registroANS)
                .subscribe((result: any) => {
                    this.dadosUniodontos = result;
                    this.pesquisa[campo] = result[campo];

                    if (campo == 'uf') {
                        this.getFiltrosCidades();
                    } else if (campo == 'cidade') {
                        this.getFiltrosBairros();
                    }
                });
        } else {
            this.pesquisa[campo] = this.dadosUniodontos[campo];

            if (campo == 'uf') {
                this.getFiltrosCidades();
            } else if (campo == 'cidade') {
                this.getFiltrosBairros();
            }
        }
    }

    getFiltrosBasicos(registroANS: string, isRedeNacional: boolean, hideLoaderAfter: boolean = false) {
        this._pesquisaService.getFiltrosBasicos(registroANS, this.pesquisa)
            .subscribe((result: any) => {
                this.filtrosPesquisa.produtos = result.produtos;
                this.filtrosPesquisa.ufs = result.ufs;
                this.filtrosPesquisa.areasAtuacao = result.areasAtuacao;

                this.setValoresDefault('uf', registroANS);

                this._loaderService.hideLoader();
                ComponentesJsService.setChosen();
            }, (error: any) => {
                alert(error);
                this._loaderService.hideLoader();
            });
    }

    getFiltrosCidades() {
        this._pesquisaService.getFiltrosCidades(this.registroANS, this.pesquisa)
            .subscribe((result: any) => {
                this.filtrosPesquisa.cidades = result.cidades;
                this._loaderService.hideLoader();

                this.setValoresDefault('cidade', this.registroANS);

            }, (error: any) => {
                alert(error);
                this._loaderService.hideLoader();
            });
    }

    getFiltrosBairros() {
        this._pesquisaService.getFiltrosBairros(this.registroANS, this.pesquisa)
            .subscribe((result: any) => {
                this.filtrosPesquisa.bairros = result.bairros;
                this._loaderService.hideLoader();
            }, (error: any) => {
                alert(error);
                this._loaderService.hideLoader();
            });
    }

    scrollParaResultados() {
        $('html, body').animate({
            scrollTop: $("#block-resultados").offset().top
        }, 1500);
    }


    public ufChange(event: Event) {
        if (this.pesquisa.uf) {
            this._loaderService.showLoader();
            this.getFiltrosCidades();
        }
    }

    public cidadeChange(event: Event) {
        if (this.pesquisa.uf && this.pesquisa.cidade != '') {
            this._loaderService.showLoader();
            this.getFiltrosBairros();
        }
    }

    public pesquisar() {
        this._loaderService.showLoader();
        this._pesquisaService.pesquisar(0, 20, this.pesquisa, this.registroANS)
            .subscribe((result: any) => {
                this.totalRecords = result.totalRecords;

                if (result.resultado) {
                    this.resultadosPesquisa = result.resultado;
                } else {
                    this.resultadosPesquisa = new Array<ResultadoPesquisa>();
                }

                this.scrollParaResultados();

                this._loaderService.hideLoader();
            }, (error: any) => {
                alert(error);
                this._loaderService.hideLoader();
            });
    }

    public localizarNoMapa(event: any) {
        this.resultadoMapa = event.value;
        var triggerMapa = document.getElementById('triggerMapa');
        triggerMapa.click();
    }

    public pageChanged(event: any) {
        this._loaderService.showLoader();
        this._pesquisaService.pesquisar(event.value.skip, event.value.take, this.pesquisa, this.registroANS)
            .subscribe((result: any) => {
                this.totalRecords = result.totalRecords;
                this.resultadosPesquisa = result.resultado;
                this._loaderService.hideLoader();
            }, (error: any) => {
                alert(error);
                this._loaderService.hideLoader();
            });
    }

    public imprimir() {
        this._loaderService.showLoader();
        this._pesquisaService.imprimir(this.pesquisa)
            .subscribe((result: any) => {
                this._loaderService.hideLoader();
                var win = window.open(result, '_blank');
                win.focus();
            }, (error) => {
                alert(error);
                this._loaderService.hideLoader();
            })
    }

    public mudarModo() {
        const tituloNotificacao = 'Mudança de modo';
        let novoModo = '';

        let modo = localStorage.getItem('modo');

        if (modo == Modo.encontreSeuDentista) {
            localStorage.setItem('modo', Modo.redeSubstituicao);
            this.pesquisa.modo = 'redeSubstituicao';
            this.pesquisa.isRedeNacional = false;
            novoModo = 'Rede de Substituição';
        } else {
            localStorage.setItem('modo', Modo.encontreSeuDentista);
            this.pesquisa.modo = 'encontreSeuDentista';
            novoModo = 'Encontre seu Dentista';
        }

        this.onRedeNacionalChange(this.pesquisa.isRedeNacional);
        this.notificar(tituloNotificacao, novoModo);

        this.resultadosPesquisa.length = 0;
    }

    public isEncontreSeuDentista() {
        return localStorage.getItem('modo') == Modo.encontreSeuDentista;
    }

    public onDigitacaoTeclado(event: any) {
        const input = document.activeElement;
        const valorAtual = input.value || '';

        if (event == 'apagar') {
            input.value = valorAtual.length > 0 ? valorAtual.substring(0, (valorAtual.length - 1)) : '';
        } else if (event == 'arroba') {
            input.value = valorAtual + '@';
        } else if (event == 'as') {
            input.value = valorAtual + '\'';
        } else if (event == 'limpar') {
            input.value = '';            
        } else {
            input.value += event;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/pesquisa-touch/pesquisa-touch.component.ts
 **/